// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".max-width{width:100%}.thumbnail-style{height:36px!important;width:64px!important;max-height:36px!important;max-width:64px!important}", ""]);
// Exports
module.exports = exports;
